import axios from 'axios';
import axiosRetry from 'axios-retry';
axiosRetry(axios, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
  shouldResetTimeout: false,
  // retryCondition: () => {
  //   return true;
  // }
});

module.exports = axios;
